import {Injectable} from '@angular/core';

@Injectable()
export class ChartSpinnerHandlerService {
    constructor() {}

    reportsRunningStatus = {};

    public isRunning(reportIdentifier) {
        return this.reportsRunningStatus[reportIdentifier];
    }

    public startLoading(reportIdentifier: string) {
        this.reportsRunningStatus[reportIdentifier] = true;
    }

    public stopLoading(reportIdentifier: string) {
        this.reportsRunningStatus[reportIdentifier] = false;
    }
}
